import { Controller } from "@hotwired/stimulus";

const MESSAGE_SET_IDS_NAME = "message_set_ids[]";

/** querySelector('[name="message_set_ids[]"]') is invalid — `]` breaks the selector. */
function messageSetCheckboxesIn(root) {
  if (!root) return [];
  return Array.from(root.querySelectorAll('input[type="checkbox"]')).filter(
    (el) => el.name === MESSAGE_SET_IDS_NAME
  );
}

export default class extends Controller {
  /**
   * Ordner-Kopf-Checkbox: alle Message-Set-Checkboxen in diesem Ordner inkl.
   * Unterordner (alles im zugehörigen <details>). Nicht dasselbe wie „Ordner löschen“.
   */
  toggleFolderSubtree(event) {
    const master = event.currentTarget;
    const scope = master.closest("details.folder-disclosure");
    if (scope) {
      messageSetCheckboxesIn(scope).forEach((el) => {
        el.checked = master.checked;
      });
      scope.querySelectorAll("thead input[type=\"checkbox\"]").forEach((el) => {
        el.checked = master.checked;
      });
      return;
    }
    const table = master.closest("table");
    if (!table) return;
    const tbody = table.querySelector("tbody");
    messageSetCheckboxesIn(tbody || table).forEach((el) => {
      el.checked = master.checked;
    });
  }

  confirmSubmit(event) {
    const form = this.element;
    const selected = messageSetCheckboxesIn(form).filter((el) => el.checked);
    if (selected.length === 0) {
      event.preventDefault();
      window.alert("Select at least one message set.");
      return;
    }
    if (
      !window.confirm(
        `Delete ${selected.length} message set(s)? This cannot be undone.`
      )
    ) {
      event.preventDefault();
    }
  }
}
